enum Breakpoint {
  Width640 = 640,
  Width768 = 768,
  Width1024 = 1024,
  Width1280 = 1280,
  Width1536 = 1536,
}

export default Breakpoint;
